<div class="modalContainer">
    <div class="modal-header">
        <h4 class="modal-title">Great Choice!</h4>
        <h4 class="modal-sub-title">The amount you wished will be redeemed to your bank account</h4>
    </div>

    <div class="modal-body">
        <h4 style="text-align: center; font-size: 18px; font-weight: 500;">Withdrawal Amount</h4>
        <div *ngIf="withdrawalRequests.length">
            <div ngClass="withdrawalRequests.length < 5 ? product-details-wrapper justify-content-center : product-details-wrapper">
                <ng-container *ngFor="let withdrawalRequest of withdrawalRequests">
                    <div class="product-code" *ngIf="withdrawalRequest.withdrawalAmount">
                        <div style="font-size: 12px; color: #a6a6a6;">
                            {{withdrawalRequest.productCode}} - Amount
                        </div>
                        <div class="product-amount">
                            ₹ {{(withdrawalRequest.withdrawalAmount | number : "1.0-2").toString()}}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="total-product-amount p-4">
            <span class="total-amount-withdraw-text mr-4">Total&nbsp;Amount&nbsp;Withdrawing&nbsp;:</span>
            <span class="font-small text-success font-bold">{{'₹&nbsp;' + (getTotalWithdrawalAmount | number : "1.0-2").toString() }}</span>
        </div>
    </div>


    <div class="modal-footer box-shadow">
        <button 
            type="button" 
            mat-stroked-button class="primary no-text-transform mr-3 buttons" 
            (click)="onMayBeLater()"
            [disabled]="withdrawalRequestInProgress"
            style="font-weight: bold;">
            MAY BE LATER
        </button>

        <button 
            type="button" 
            mat-flat-button class="primary no-text-transform continue-button buttons font-weight-bold"
            [class.plain-spinner]="withdrawalRequestInProgress"
            [disabled]="getTotalWithdrawalAmount < 1 || withdrawalRequestInProgress"
            cdkFocusInitial 
            (click)="onConfirmWithdrawal()">
                CONFIRM WITHDRAWAL
        </button>
    </div>
</div>